export default {
  RIGHT_ANSWER_SURVEYS_FETCHED: 'RIGHT_ANSWER_SURVEYS_FETCHED',
  RIGHT_ANSWER_SURVEY_LOAD: 'RIGHT_ANSWER_SURVEY_LOAD',
  RIGHT_ANSWER_SURVEY_DETAIL: 'RIGHT_ANSWER_SURVEY_DETAIL',
  RESEARCH_TEMPLATES_FETCHED: 'RESEARCH_TEMPLATES_FETCHED',
  RESEARCH_TEMPLATES_LOAD: 'RESEARCH_TEMPLATES_LOAD',
  RIGHT_ANSWER_SURVEY_BUTTON_LOAD: 'RIGHT_ANSWER_SURVEY_BUTTON_LOAD',
};
